import React, { useState, useEffect } from "react";
import RichTextEditor from "../../../components/RichTextEditor";
import { useTranslation } from "react-i18next";
import DirectoryApi from "../../../api/directoryApi";
import ProgramApi from "../../../api/programApi";
import { toast } from "react-toastify";
import { Form, Button, Modal } from "react-bootstrap";
import { useAuthUser } from "../../../hooks/useAuthUser";

interface ProgramModelProps {
  show: boolean;
  onHide: () => void;
  programField?: string;
  program?: Record<string, any> | null;
  coupleTalkData?: Record<string, any> | null;
  retreatData?: Record<string, any> | null;
}

const ProgramModel = ({
  show,
  onHide,
  programField,
  program,
  coupleTalkData,
  retreatData,
}: ProgramModelProps) => {
  const { t } = useTranslation();
  const userData = useAuthUser();
  const [validated, setValidated] = useState(false);
  const [text, setText] = useState("");
  let programApi = new ProgramApi();

  const tp = (key: any) => {
    return t(key, {
      lng: retreatData?.language === "spanish" ? "spanish" : "english",
    });
  };

  useEffect(() => {
    if (programField === "WisdomDescription") {
      setText(program?.wisdom_from_mt || "");
    } else if (programField === "talk_question") {
      setText(
        coupleTalkData?.talk_question ||
          '<div style="margin: 10px 0;"><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /></div>',
      );
    } else if (programField === "tableContent") {
      setText(program?.tableContent || "");
    } else if (programField === "ParishMission") {
      setText(program?.parishMission || "");
    } else if (programField === "fbLink") {
      setText(program?.fbLink || "");
    } else if (programField === "instaLink") {
      setText(program?.instaLink || "");
    } else if (programField === "openingPrayer") {
      setText(program?.openingPrayer || tp("opening_prayer_content"));
    } else if (programField === "prayerOfProtection") {
      setText(
        program?.prayer_of_protection || tp("prayer_protection_content"),
      );
    } else if (programField === "donations") {
      setText(program?.donations || tp("donations_content"));
    } else {
      setText(program?.guidelines || "");
    }
  }, [programField, program, coupleTalkData, retreatData?.language]);

  const handleSubmit = async () => {
    try {
      const res = await programApi.createProgram({
        text: text,
        programField: programField,
        retreatId: retreatData && retreatData.id,
        programId: program && program.id,
        roasterId: coupleTalkData && coupleTalkData.id,
      });

      if (!res.success) {
        toast.error(res.msg);
        return;
      }

      if (res.mode === "create") {
        
      } else if (programField === "WisdomDescription") {
        
      } else if (programField === "talk_question") {
        
      } else if (programField === "ParishMission") {
        
      } else if (programField === "tableContent") {
        
      } else if (programField === "fbLink") {
        
      } else if (programField === "instaLink") {
        
      } else if (programField === "openingPrayer") {
        
      } else {
        
      }

      toast.success(res.msg);
      onHide();
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <>
      {programField === "fbLink" ? (
        <Modal
          show={show}
          onHide={onHide}
          size={"md" as any}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("facebook_link")}
            </Modal.Title>
          </Modal.Header>
          <Form noValidate validated={validated} className="forms-sample">
            <Modal.Body>
              <Form.Group className="form-group ml-5 faceBbook-link">
                <Form.Control
                  size="sm"
                  type="text"
                  name="fbLink"
                  id="fbLink"
                  placeholder={t("facebook_link")}
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
                <h5 className="mt-2">{t("example_link")}</h5>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="footer-buttons">
              <Button onClick={handleSubmit} variant="primary" type="button">
                {t("save")}
              </Button>
              <Button onClick={onHide}>{t("close")}</Button>
            </Modal.Footer>
          </Form>
        </Modal>
      ) : programField === "instaLink" ? (
        <Modal
          show={show}
          onHide={onHide}
          size={"md" as any}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("instagram_link")}
            </Modal.Title>
          </Modal.Header>
          <Form noValidate validated={validated} className="forms-sample">
            <Modal.Body>
              <Form.Group className="form-group ml-5 faceBbook-link">
                <Form.Control
                  size="sm"
                  type="text"
                  name="instaLink"
                  id="instaLink"
                  placeholder={t("instagram_link")}
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
                <h5 className="mt-2">{t("example_link")}</h5>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="footer-buttons">
              <Button onClick={handleSubmit} variant="primary" type="button">
                {t("save")}
              </Button>
              <Button onClick={onHide}>{t("close")}</Button>
            </Modal.Footer>
          </Form>
        </Modal>
      ) : (
        <Modal
          show={show}
          onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            {programField === "WisdomDescription" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("wisdom_mother_theresa")}
              </Modal.Title>
            ) : null}

            {programField === "guidelines" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("add_guidelines")}
              </Modal.Title>
            ) : null}

            {programField === "openingPrayer" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("opening_prayer")}
              </Modal.Title>
            ) : null}

            {programField === "ParishMission" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("our_parish_mission")}
              </Modal.Title>
            ) : null}

            {programField === "prayerOfProtection" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("marriage_prayer_of_protection")}
              </Modal.Title>
            ) : null}

            {programField === "donations" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("donations")}
              </Modal.Title>
            ) : null}

            {programField === "talk_question" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("talks_questions")}
                <h5 className="mt-2">
                  {coupleTalkData.talk}, (
                  {coupleTalkData.role === "Spiritual Director"
                    ? `${coupleTalkData?.firstName || ""} ${coupleTalkData?.lastName || ""}`
                    : `${coupleTalkData?.hisFirstName || ""} ${
                        coupleTalkData?.hisFirstName ? "&" : ""
                      } ${coupleTalkData?.herFirstName || ""} ${
                        coupleTalkData?.hisLastName || ""
                      }`}
                  )
                </h5>
              </Modal.Title>
            ) : null}
          </Modal.Header>
          <Form noValidate validated={validated} className="forms-sample">
            <Modal.Body>
              <RichTextEditor
                value={text}
                onChange={(e) => setText(e)}
                variant="modal"
              />
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={handleSubmit} variant="primary" type="button">
                {t("save")}
              </Button>
              <Button onClick={onHide}>{t("close")}</Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default ProgramModel;
